"use client";

import { colorPartsOf } from "@v2/lib/colorParts";
import { usePdpVariant } from "./PdpVariantContext";
import PdpMobileGallery from "./PdpMobileGallery";

type Props = {
    frameTypeAttr?: string;
    materialAttr?: string;
    brandName?: string;
};

export default function PdpGalleryMobileSection({ frameTypeAttr, materialAttr, brandName }: Props) {
    const { showProduct } = usePdpVariant();

    const supersedeAlt = [
        showProduct.product_class?.title,
        frameTypeAttr,
        materialAttr,
        brandName,
        ...colorPartsOf(showProduct).map(part => part.colors.map(c => c.title).join(", ")),
    ].filter(Boolean).join(" - ");

    return (
        <PdpMobileGallery
            images={showProduct.images}
            details={{ supersede_alt: supersedeAlt }}
        />
    );
}
